angular.module("warsApp.factories").factory('noCacheInterceptor', function () {
    return {
        request: function (config) {
            if (config.method == 'GET') {
                if (!config.url.toLowerCase().endsWith('.html')) {
                    var separator = config.url.indexOf('?') === -1 ? '?' : '&';
                    config.url = config.url + separator + 'noCache=' + new Date().getTime();
                }
            }

            return config;
        }
    };
});